import React from "react";
import { Route, Routes } from "react-router-dom";

import TenantReportDetails from "js/components/Tenants/TenantReportDetails";

import MembershipPermission from "js/pages/MembershipPermission";
import NotFound from "js/pages/NotFound";
import TenantsDashboard from "js/pages/Tenants/TenantsDashboard";

import permissions from "../utils/membershipPermissions";

const Tenant = () => {
  return (
    <Routes>
      <Route
        path=""
        element={
          <MembershipPermission
            requiredPermission={permissions.tenantRegistration}
          >
            <TenantsDashboard />
          </MembershipPermission>
        }
      />
      <Route path="reports/:reportId" element={<TenantReportDetails />} />
      <Route path="*" element={<NotFound />} />
    </Routes>
  );
};

export default Tenant;
